import { Component, OnInit } from '@angular/core';

import { ScheduleService } from '../../../services/schedule.service';
import { Show } from '../../../services/schedule.model';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {
  public shows: Show[];
  public activeId: number;

  constructor(private ss: ScheduleService) {
    this.activeId = -1;
  }

  formatTime(date: string): string {
    return this.ss.formatTime(date);
  }

  ngOnInit(): void {
    this.ss.scheduleData.subscribe(data => {
      if (data.upcoming === undefined) {
        this.shows = undefined;
      } else {
        this.shows = JSON.parse(JSON.stringify(data.upcoming));

        for (const key in this.shows) {
          if (this.shows.hasOwnProperty(key)) {
            this.shows[key].name += '<img src="/assets/icons/expand.svg" class="chevron" alt="Expand icon">';
          }
        }
      }
    });
  }

  toggleActiveShow(i: number): void {
    if (i === this.activeId) {
      this.activeId = -1;
    } else {
      this.activeId = i;
    }
  }
}
